export function buildQueryString(params) {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '' && !(Array.isArray(value) && value.length === 0)) {
            query.append(key, Array.isArray(value) ? value.join(',') : value);
        }
    });

    return query.toString();
}
